var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.isAdmin)?_c('DashboardAdmin'):_vm._e(),(_vm.isClient)?_c('DashboardClient'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }